import { createReducer, on } from '@ngrx/store';
import { loadedMenu, MenuData } from './menu.actions';

export const menuInitialState: MenuData = null;

export const menuReducer = createReducer(
  menuInitialState,
  on(loadedMenu, (state, { menu }) => menu)
);
